import { gql } from "apollo-boost";

export const GET_ALL_LEAGUES = gql`
  query {
    allLeague {
      edges {
        node {
          seqno
          name
          description
          logo
          sport
          website
          updateSource
          params
        }
      }
    }
  }
`;

// Return attitude leagues to clubs
export const LEAGUES_ATTITUDE_TO_CLUBS = gql`
  query allLeagueClubRel {
    allLeagueClubRel {
      edges {
        node {
          seqno
          leagueSeqno
          clubId
          league {
            seqno
          }
          club {
            id
            clubName
          }
        }
      }
    }
  }
`;
